import { PageLayout } from '../components/Layout/PageLayout';
import { Hero } from '../components/Hero';
import { Game } from '../components/Game';

export function HomePage() {
  return (
    <PageLayout
      hero={<Hero />}
      game={<Game />}
    />
  );
}